// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;
  // SIDEBAR
  return (
    <Flex direction='column' height='100%' px='1rem' py='1.5rem'>
      <Brand />
      <Stack direction='column'>
        <Box>
          <Links routes={routes} />
        </Box>
      </Stack>

    </Flex>
  );
}

export default SidebarContent;
